import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Theme, Card, Flex, Text, Link, Button } from "@radix-ui/themes";
import { FaLinkedin, FaGithub, FaTwitter, FaGlobe } from "react-icons/fa";
import Cal from "@calcom/embed-react";

function CyberNeon({ user }) {
  const [showCalendar, setShowCalendar] = useState(false);

  return (
    <Theme appearance="dark" accentColor="violet">
      <Helmet>
        <title>{user?.name} | Profiles</title>
        <meta
          name="description"
          content={`${user?.name}'s profile on Profiler. View links, bio, and schedule meetings.`}
        />
      </Helmet>
      <div style={{ background: "#0f0f23", minHeight: "100vh" }}>
        {!showCalendar ? (
          <Flex
            align="center"
            justify="center"
            style={{ height: "100vh", padding: "2rem" }}
          >
            <Card
              size="4"
              style={{
                maxWidth: "480px",
                width: "100%",
                borderRadius: "20px",
                backgroundColor: "#1a1a2e",
                border: "2px dashed violet",
                color: "#fff",
                padding: "2rem",
                boxShadow: "0 0 24px violet",
              }}
            >
              <Text size="5" weight="bold" color="violet">
                {user.name}
              </Text>
              &nbsp;
              <Text color="gray">@{user.username}</Text> <br />
              <Text my="3" style={{ color: "#ddd" }}>
                {user.description}
              </Text>
              <hr style={{ border: "1px dashed violet", margin: "1.5rem 0" }} />
              <Flex gap="4" mt="1" align="center" wrap="wrap">
                {user.socialLinks?.linkedin && (
                  <Link
                    href={user.socialLinks.linkedin}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#ccc",
                    }}
                  >
                    <FaLinkedin /> LinkedIn
                  </Link>
                )}
                {user.socialLinks?.github && (
                  <Link
                    href={user.socialLinks.github}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#ccc",
                    }}
                  >
                    <FaGithub /> GitHub
                  </Link>
                )}
                {user.socialLinks?.twitter && (
                  <Link
                    href={user.socialLinks.twitter}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#ccc",
                    }}
                  >
                    <FaTwitter /> Twitter
                  </Link>
                )}
                {user.socialLinks?.website && (
                  <Link
                    href={user.socialLinks.website}
                    target="_blank"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#ccc",
                    }}
                  >
                    <FaGlobe /> Website
                  </Link>
                )}
              </Flex>
              {user.calcomUsername && (
                <Flex justify="center">
                  <Button
                    mt="4"
                    variant="solid"
                    color="violet"
                    onClick={() => setShowCalendar(true)}
                  >
                    Schedule Meeting
                  </Button>
                </Flex>
              )}
            </Card>
          </Flex>
        ) : (
          <Flex
            justify="center"
            style={{
              animation: "fadeIn 400ms ease-in-out",
              paddingTop: "4rem",
            }}
          >
            <div style={{ width: "100%", overflow: "hidden" }}>
              <Cal calLink={`${user.calcomUsername}/15min`} />
            </div>
          </Flex>
        )}

        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(10px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>
      </div>
    </Theme>
  );
}

export default CyberNeon;
